export enum FormElementMode {
  Editor = 0,
  Runner = 1,
  Viewer = 2,
  RunnerPreview = 3,
  Completion = 4,
}
